import { values } from 'lodash-es';

import type { LookoRouteObject } from '@/router/LookoRouteObject';

/**
 * shopAuth 가 없을 때도 사용할 수 있는 라우터
 */
export const 플랜_게스트_라우터 = {
  플랜요금_계산기: {
    path: '/plan-calculator',
    async lazy() {
      const { default: Page } = await import('@/router/plan/플랜요금_계산기_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: 'Looko-AI 요금 계산기',
    },
  } satisfies LookoRouteObject,
};

/**
 * shopAuth 가 있을 때 사용하는 라우터
 */
export const 플랜_라우터 = {
  플랜요금: {
    path: '/pricing',
    async lazy() {
      const { default: Page } = await import('@/router/plan/플랜요금_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '서비스 요금',
    },
  } satisfies LookoRouteObject,
};

export const 플랜_게스트_라우터_루트: LookoRouteObject[] = [...values(플랜_게스트_라우터)];
export const 플랜_라우터_루트: LookoRouteObject[] = [...values(플랜_라우터)];
